import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiPagination: {
      defaultProps: {
        shape: 'rounded',
        showFirstButton: true,
        showLastButton: true,
      },
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx } }) =>
          sx({
            my: 2,
          }),
        ul: { justifyContent: 'flex-end' },
      },
    },
  },
});

export default theme.components;
